module.exports = __webpack_public_path__ + "img/platform-4-icon.0aa7001f.svg";